// opervex-frontend/src/Opervex/Report/StockSerial.js

class StockSerial {
  #api;

  constructor(api) {
    this.#api = api;
  }

  async schema() {
    return [
      {
        key: "product",
        label: "Produto",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "serialNumber",
        label: "Nº de série",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "mac",
        label: "MAC",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "deposit",
        label: "Depósito",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "depositType",
        label: "Tipo Depósito",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "depositTypeText",
        label: "Texto Tipo Depósito",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "acronym",
        label: "Sigla Depósito",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "depositText",
        label: "Texto Depósito",
        type: "string",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default StockSerial;
